(() => {
  const widgets = document.querySelectorAll('[data-header-search-mini]');
  if (!widgets.length) return;

  const rootPath = window.Shopify?.routes?.root || '/';
  const MIN_CHARS = 2;
  const MIN_CHARS_MSG = `Type at least ${MIN_CHARS} letters to search`;

  widgets.forEach((details) => {
    const overlay = details.querySelector('[data-search-overlay]');
    const form = details.querySelector('[data-search-form]');
    const input = details.querySelector('[data-search-input]');
    const resultsEl = details.querySelector('[data-search-results]');
    const actionBtn = details.querySelector('[data-search-action]');

    if (!input || !resultsEl || !actionBtn || !form) return;

    const hideResults = () => {
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };

    const showResults = (html) => {
      resultsEl.innerHTML = html;
      resultsEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const showMinCharsHint = () => {
      showResults(`<div style="padding:10px 0; opacity:.75;">${MIN_CHARS_MSG}</div>`);
    };

    const close = () => {
      details.removeAttribute('open');
      hideResults();
      input.value = '';
    };

    const clearOnly = () => {
      input.value = '';
      hideResults();
      input.focus();
    };

    details.addEventListener('toggle', () => {
      if (details.open) {
        window.setTimeout(() => input.focus(), 0);
        // Show hint immediately when opened (optional but useful)
        showMinCharsHint();
      } else {
        hideResults();
      }
    });

    overlay?.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && details.open) close();
    });

    // X: clear if typing, else close
    actionBtn.addEventListener('click', () => {
      if (input.value.trim().length) clearOnly();
      else close();
    });

    // Close when clicking a suggestion
    resultsEl.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (a) close();
    });

    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();

      // Empty -> show hint (instead of nothing)
      if (!q) {
        showMinCharsHint();
        return;
      }

      // Not enough chars -> show hint
      if (q.length < MIN_CHARS) {
        showMinCharsHint();
        return;
      }

      t = setTimeout(async () => {
        try {
          // Title-only matching for predictive search
          const url =
            `${rootPath}search/suggest.json` +
            `?q=${encodeURIComponent(q)}` +
            `&resources[type]=product` +
            `&resources[limit]=6` +
            `&resources[options][unavailable_products]=hide` +
            `&resources[options][fields]=title`;

          const res = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!res.ok) throw new Error(`Suggest failed: ${res.status}`);
          const data = await res.json();

          const products = data?.resources?.results?.products || [];

          if (!products.length) {
            showResults(`<div style="padding:10px 0; opacity:.75;">No products found</div>`);
            return;
          }

          const html = products
            .map((p) => {
              const img = p.featured_image?.url
                ? `<img src="${escapeAttr(p.featured_image.url)}" alt="${escapeAttr(p.featured_image.alt || p.title)}" loading="lazy">`
                : `<div style="width:44px;height:44px;border-radius:6px;background:rgba(0,0,0,.06)"></div>`;

              const price = formatMoneyPDPStyle(p.price);
              const compare = p.compare_at_price ? formatMoneyPDPStyle(p.compare_at_price) : '';

              const priceHtml =
                price || compare
                  ? `<div class="header-search-mini__result-price">
                       ${price ? `<span class="price-current">${price}</span>` : ``}
                       ${compare ? `<span class="price-compare">${compare}</span>` : ``}
                     </div>`
                  : ``;

              return `
                <a class="header-search-mini__result" href="${escapeAttr(p.url)}">
                  ${img}
                  <div>
                    <div class="header-search-mini__result-title">${escapeHtml(p.title)}</div>
                    ${priceHtml}
                  </div>
                </a>
              `;
            })
            .join('');

          showResults(html);
        } catch (err) {
          // If it errors, don’t leave stale results hanging
          showResults(`<div style="padding:10px 0; opacity:.75;">Search unavailable</div>`);
          console.warn(err);
        }
      }, 150);
    });

    // --- money formatting: handles cents OR dollars safely ---
    function normalizeToCents(value) {
      if (value == null) return null;
      const n = Number(value);
      if (!Number.isFinite(n)) return null;

      // dollars -> cents (800 => 80000), cents stay cents (80000 => 80000)
      // heuristic: integer and < 10000 => dollars
      if (Number.isInteger(n) && n < 10000) return Math.round(n * 100);
      return Math.round(n);
    }

    /**
     * ALWAYS returns: "$800.00 USD"
     * Ensures "$" is present and USD is present, no duplicates.
     */
    function formatMoneyPDPStyle(value) {
      const cents = normalizeToCents(value);
      if (cents == null) return '';

      let raw = '';
      try {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          raw = Shopify.formatMoney(cents, '${{amount}}');
        }
      } catch (e) {}

      if (!raw) {
        raw = (cents / 100).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }

      const match = String(raw).match(/(\d[\d,]*\.?\d*)/);
      const amount = match ? match[1] : (cents / 100).toFixed(2);

      return `$${amount} USD`;
    }

    function escapeHtml(str) {
      return String(str)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }

    function escapeAttr(str) {
      return escapeHtml(str).replaceAll('`', '&#096;');
    }
  });
})();
